module.exports = __webpack_public_path__ + "static/media/helvaci-color.79d539ae.svg";